// extracted by mini-css-extract-plugin
module.exports = {"root":"NextPayout_root__U8wcd","content":"NextPayout_content__uiKaK","title":"NextPayout_title__TP2O7","value":"NextPayout_value__jeUCx"};